import { Component } from '@angular/core';

@Component({
  selector: 'app-footer',
  template: `<footer>
    <a style="align-self: flex-start" href="movesion.com" target="_blank"
      >movesion.com</a
    >
    <a style="align-self: flex-end" href="#"
      >2021 MOVESION | Privacy & Cookie Policy</a
    >
  </footer>`,
  styles: [
    'footer {display:flex; flex-direction: row;color:white;z-index: 200;justify-content: space-around;align-content: baseline}',
    ':host{width:100%;}',
    'a{ color: #FFFFFF; opacity: 0.4; }',
    'a:first-child{letter-spacing: 0.85px; font-size: 17px; font-family: Ubuntu;}',
    'a:last-child{letter-spacing: 0.85px; font-size: 11px; font-family: Ubuntu;}',
  ],
})
export class FooterComponent {
  constructor() {}
}
